import 'css-chunksrc/client/scenes/projectsTransfer/styles.scss';export default {
  "projectsTransfer": "_projectsTransfer_1aqjm_1",
  "header": "_header_1aqjm_9",
  "title": "_title_1aqjm_14",
  "message": "_message_1aqjm_20",
  "main": "_main_1aqjm_26",
  "buttons": "_buttons_1aqjm_35",
  "projects": "_projects_1aqjm_1",
  "destination": "_destination_1aqjm_53",
  "wrapper": "_wrapper_1aqjm_62",
  "destinationHeader": "_destinationHeader_1aqjm_73",
  "icon": "_icon_1aqjm_77",
  "zonesList": "_zonesList_1aqjm_82"
};